import { UpdateMachinePayload } from "@src/types/gateways-with-machines";
import { Machine } from "@src/cloud-connect/api/client-configuration/get-machine-by-id";
import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface UpdateMachineResult {
  success: boolean;
  data?: Machine;
  error?: string;
}

export const updateMachineUseCase = async (
  machineId: string,
  payload: UpdateMachinePayload,
): Promise<UpdateMachineResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext?.customerNamespace;
    if (!namespace) {
      return { success: false, error: "Customer namespace is unavailable." };
    }

    const response = await apiUseCases.putUpdateMachine(
      namespace,
      machineId,
      payload,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update machine").message,
    };
  }
};
